// src/pages/ChildSafety.jsx
import React from "react";
import { Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ChildSafety = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        backgroundImage: `url(${require("../assets/images/landing_background.jpg")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        fontFamily: "'Baloo Bhaijaan 2', cursive",
        color: "white",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <header
        style={{
          width: "100%",
          padding: "10px 20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.5)",
        }}
      >
        <img
          src={require("../assets/images/logo_name.PNG")}
          alt="YourStoryWorld Logo"
          style={{ height: "40px", cursor: "pointer" }}
          onClick={() => navigate("/")}
        />
        <div>
          <Button color="inherit" onClick={() => navigate("/")}>
            Home
          </Button>
          <Button color="inherit" onClick={() => navigate("/login")}>
            Sign In
          </Button>
          <Button color="inherit" onClick={() => navigate("/help")}>
            Help
          </Button>
        </div>
      </header>

      {/* Content */}
      <Container
        maxWidth="md"
        style={{
          marginTop: "30px",
          marginBottom: "30px",
          background: "rgba(255, 255, 255, 0.97)",
          borderRadius: "10px",
          padding: "30px 20px",
          color: "#333",
        }}
      >
        <Typography variant="h4" gutterBottom>
          Child Safety & Online Protection
        </Typography>
        <Typography variant="subtitle2" gutterBottom>
          Last Updated: December 2025
        </Typography>
        <Typography variant="body2" paragraph>
          YourStoryWorld is operated by Yourstoryworld Ltd (Company No.
          17098564), United Kingdom. We are committed to providing a safe,
          age-appropriate environment for children and young people using our
          platform.
        </Typography>

        <Typography variant="h6" gutterBottom>
          1. Adult-managed accounts
        </Typography>
        <Typography variant="body2" paragraph>
          Children use YourStoryWorld under the supervision of adults (parents,
          carers, teachers or school staff). Adults are responsible for:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">
              Creating and managing accounts and login credentials.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Choosing appropriate settings, such as age group, phonics mode and
              reading level.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Reviewing stories and content where needed.
            </Typography>
          </li>
        </ul>


        <Typography variant="h6" gutterBottom>
          2. Content safeguarding
        </Typography>
        <Typography variant="body2" paragraph>
          We design our prompts and filters to produce age-appropriate,
          education-focused stories. However, as some content is AI-generated:
        </Typography>
        <ul>
          <ul>
  <li><strong>❌ No violence or harm</strong> — physical conflict, weapons, frightening scenes or threats are removed.</li>
  <li><strong>❌ No explicit or romantic content</strong> — dating, intimacy, sexuality or adult themes are blocked.</li>
  <li><strong>❌ No inappropriate language</strong> — swearing, insults or discriminatory terms are filtered.</li>
  <li><strong>❌ No drugs, alcohol, self-harm or unsafe behaviour.</strong></li>
  <li><strong>✔ Age-appropriate vocabulary</strong> — writing is adapted to each child's reading level.</li>
  <li><strong>✔ Phonics-friendly options</strong> for early readers.</li>
  <li><strong>✔ Teacher oversight</strong> — assigned themes help guide story direction.</li>
</ul>
        </ul>
        <Typography variant="body2" paragraph>
          If you encounter content that you think is inappropriate for children,
          please contact us at{" "}
          <a href="mailto:support@yourstoryworld.com">support@yourstoryworld.com</a>{" "}
          with details so we can investigate and refine our safeguards.
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. Data protection for children
        </Typography>
        <Typography variant="body2" paragraph>
          We aim to minimise the personal information we collect about children:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">
              We encourage use of first name only or nicknames.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              We do not use children’s data for behavioural advertising.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Parents and schools can request deletion of child profiles and
              associated data.
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          4. Voice recordings
        </Typography>
        <Typography variant="body2" paragraph>
          Some plans allow children to record themselves reading stories aloud.
          These recordings are:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">
              Stored securely and linked to the child’s profile.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Visible only to the associated parent/teacher/school account
              (depending on plan).
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Used for educational feedback, not for advertising or external
              profiling.
            </Typography>
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          5. Online behaviour
        </Typography>
        <Typography variant="body2" paragraph>
          YourStoryWorld is not a public social network. Children do not have
          open chat or public posting features within the platform. Any sharing
          of stories or recordings is done within controlled school or family
          contexts, or via export by the responsible adult.
        </Typography>

        <Typography variant="h6" gutterBottom>
          6. If you have concerns
        </Typography>
        <Typography variant="body2" paragraph>
          If you are worried about a child’s safety online, or believe our
          platform has been used in an inappropriate way, please:
        </Typography>
        <ul>
          <li>
            <Typography variant="body2">
              Contact us immediately at{" "}
              <a href="mailto:support@yourstoryworld.com">
                support@yourstoryworld.com
              </a>
              .
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              Consider speaking to your school’s safeguarding lead, if applicable.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              In an emergency or where a child is at immediate risk, contact the
              relevant local authorities.
            </Typography>
          </li>
        </ul>
      </Container>
    </div>
  );
};

export default ChildSafety;
